/* Recherche des références constructeur : lecture des métachamps publics dans le thème.
 * Aucun changement du catalogue, des SKU ou de l’index natif Shopify.
 * Le cache de références expire après deux minutes ; les cartes/prix sont rendus par Shopify.
 */
(function (root) {
  'use strict';
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  function aliases(value) {
    return Array.from(new Set(String(value || '').split(/[/,;|&\r\n]+|\s+(?:ou|et)\s+/i).map(normalize).filter(Boolean)));
  }
  function isReference(value) {
    var text = String(value || '').trim();
    var clean = normalize(text);
    return clean.length >= 3 && /^[a-z0-9\s._/(),;|&-]+$/i.test(text) &&
      ((text.match(/[0-9]/g) || []).length >= 2 || (clean.length >= 5 && text === text.toUpperCase()));
  }
  function rankMatches(records, query) {
    var queries = aliases(query).filter(function (ref) { return ref.length >= 3; });
    if (!queries.length) return [];
    return records.reduce(function (out, record) {
      var refs = aliases(record.r);
      if (refs.some(function (ref) { return queries.some(function (queryRef) { return ref.indexOf(queryRef) === 0; }); })) {
        out.push(Object.assign({}, record, { exact: queries.some(function (queryRef) { return refs.indexOf(queryRef) !== -1; }) }));
      }
      return out;
    }, []).sort(function (a, b) {
      return Number(b.exact) - Number(a.exact) || Number(b.a) - Number(a.a) || a.t.localeCompare(b.t, 'fr');
    });
  }
  function mergeResults(matches, nativeResults) {
    var seen = new Set();
    return matches.concat(nativeResults).filter(function (record) {
      if (!record.h || seen.has(record.h)) return false;
      seen.add(record.h);
      return true;
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalize: normalize, aliases: aliases, isReference: isReference, rankMatches: rankMatches, mergeResults: mergeResults };
  if (!root.document) return;

  var config = root.LpaReferenceSearchConfig || {};
  var rootPath = (config.root || '/').replace(/\/$/, '');
  var collectionPath = config.collection || rootPath + '/collections/all';
  var searchPath = config.search || rootPath + '/search';
  var productsPath = rootPath + '/products/';
  var cacheKey = 'lpa-oem-v1:' + config.theme + ':' + rootPath;
  var lifetime = 120000;
  var index = null;
  var indexAt = 0;
  var indexPromise = null;
  var productPromises = new Map();
  var nativePromises = new Map();

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]; });
  }
  async function parallelMap(items, limit, action) {
    var cursor = 0;
    var output = new Array(items.length);
    await Promise.all(Array.from({ length: Math.min(limit, items.length) }, async function () {
      while (cursor < items.length) {
        var current = cursor++;
        output[current] = await action(items[current], current);
      }
    }));
    return output;
  }
  async function fetchJSON(url) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 18000);
    try {
      var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Reference search: HTTP ' + response.status);
      var data = await response.json();
      if (data.schema !== 'lpa-oem-v1') throw new Error('Reference search: invalid response');
      return data;
    } finally { clearTimeout(timer); }
  }
  async function loadPages(path, parameters) {
    function url(page) {
      var address = new URL(path, root.location.origin);
      Object.keys(parameters).forEach(function (key) { address.searchParams.set(key, parameters[key]); });
      address.searchParams.set('page', page);
      return address;
    }
    var first = await fetchJSON(url(1));
    if (!Array.isArray(first.products) || first.pages > 100) throw new Error('Reference search: pagination unavailable');
    var pages = Array.from({ length: Math.max(0, first.pages - 1) }, function (_, i) { return i + 2; });
    var rest = await parallelMap(pages, 6, function (page) { return fetchJSON(url(page)); });
    var all = [first].concat(rest);
    all.forEach(function (data, position) {
      if (data.page !== position + 1 || !Array.isArray(data.products)) throw new Error('Reference search: incomplete pagination');
    });
    var seen = new Set();
    return all.flatMap(function (page) { return page.products; }).filter(function (item) {
      if (!item.h || seen.has(item.h)) return false;
      seen.add(item.h);
      return true;
    });
  }
  async function loadIndex() {
    if (index && Date.now() - indexAt < lifetime) return index;
    if (indexPromise) return indexPromise;
    try {
      var stored = JSON.parse(root.sessionStorage.getItem(cacheKey) || 'null');
      if (stored && Date.now() - stored.at < lifetime && Array.isArray(stored.products)) {
        index = stored.products;
        indexAt = stored.at;
        return index;
      }
    } catch (_) { /* Le mode privé peut refuser le stockage ; la recherche fonctionne sans cache. */ }
    indexPromise = loadPages(collectionPath, { view: 'lpa-reference-index', sort_by: 'created-ascending' }).then(function (products) {
      index = products;
      indexAt = Date.now();
      try { root.sessionStorage.setItem(cacheKey, JSON.stringify({ at: indexAt, products: products })); } catch (_) { /* Cache facultatif. */ }
      return products;
    }).finally(function () { indexPromise = null; });
    return indexPromise;
  }
  async function find(query) { return rankMatches(await loadIndex(), query); }
  function productURL(handle) { return productsPath + encodeURIComponent(handle); }
  function details(record) {
    if (!productPromises.has(record.h)) {
      var url = new URL(productURL(record.h), root.location.origin);
      url.searchParams.set('view', 'lpa-reference-result');
      productPromises.set(record.h, fetchJSON(url).then(function (data) {
        if (data.hidden || typeof data.card !== 'string' || typeof data.suggestion !== 'string') throw new Error('Reference search: product unavailable');
        return data;
      }).catch(function (error) { productPromises.delete(record.h); throw error; }));
    }
    return productPromises.get(record.h);
  }
  // Rendu groupé des cartes : au plus 12 handles par requête (limite Liquid : 20).
  async function warmDetails(records) {
    var missing = records.filter(function (record) { return !productPromises.has(record.h); });
    var chunks = [];
    for (var i = 0; i < missing.length; i += 12) chunks.push(missing.slice(i, i + 12));
    await parallelMap(chunks, 2, async function (chunk) {
      var url = new URL(searchPath, root.location.origin);
      url.searchParams.set('view', 'lpa-reference-cards');
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', chunk.map(function (record) { return record.h; }).join(','));
      var request = fetchJSON(url);
      chunk.forEach(function (record) {
        productPromises.set(record.h, request.then(function (data) {
          var detail = Array.isArray(data.products) && data.products.find(function (product) { return product.handle === record.h; });
          if (!detail || detail.hidden || typeof detail.card !== 'string') throw new Error('Reference search: missing product card');
          return detail;
        }).catch(function (error) { productPromises.delete(record.h); throw error; }));
      });
      await Promise.all(chunk.map(function (record) { return productPromises.get(record.h).catch(function () { return null; }); }));
    });
  }
  function fallbackSuggestion(record) {
    return '<li role="option" aria-selected="false" class="predictive-search__list-item"><a tabindex="-1" class="predictive-search__item link" href="' + productURL(record.h) + '"><div class="predictive-search__item-content"><p class="predictive-search__item-heading">' + escapeHTML(record.t) + '</p><p class="lpa-reference-suggestion__ref">Réf. : ' + escapeHTML(record.r) + '</p></div></a></li>';
  }
  async function enrichPredictive(markup, query) {
    if (!isReference(query)) return markup;
    var matches = await find(query);
    if (!matches.length) return markup;
    var selected = matches.slice(0, 8);
    await warmDetails(selected);
    var suggestions = await parallelMap(selected, 4, function (record) {
      return details(record).then(function (data) { return data.suggestion; }).catch(function () { return fallbackSuggestion(record); });
    });
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var results = doc.querySelector('#predictive-search-results');
    if (!results) return markup;
    var handles = new Set(selected.map(function (record) { return record.h; }));
    results.querySelectorAll('li.predictive-search__list-item').forEach(function (item) {
      var link = item.querySelector('a[href]');
      if (!link) return;
      var path = new URL(link.getAttribute('href'), root.location.origin).pathname;
      var handle = path.split('/products/')[1];
      if (handle && handles.has(decodeURIComponent(handle))) item.remove();
    });
    var group = doc.createElement('div');
    group.className = 'lpa-reference-suggestions';
    group.innerHTML = '<h2 class="predictive-search__heading text-body">Références constructeur</h2><ul class="predictive-search__results-list list-unstyled" role="group" aria-label="Pièces correspondant à la référence constructeur">' + suggestions.join('') + '</ul>';
    results.prepend(group);
    var count = doc.querySelector('[data-predictive-search-live-region-count-value]');
    if (count) count.textContent = matches.length + (matches.length > 1 ? ' pièces correspondent à la référence constructeur.' : ' pièce correspond à la référence constructeur.');
    return doc.body.innerHTML;
  }
  function nativeResults(query) {
    if (!nativePromises.has(query)) {
      nativePromises.set(query, loadPages(searchPath, { view: 'lpa-reference-native', type: 'product', q: query, 'options[prefix]': 'last' }).catch(function (error) {
        nativePromises.delete(query);
        throw error;
      }));
    }
    return nativePromises.get(query);
  }
  function fallbackCard(record) {
    return '<div class="lpa-reference-fallback"><h3>' + escapeHTML(record.t) + '</h3><p>Réf. : ' + escapeHTML(record.r) + '</p><a class="lpa-btn lpa-btn--primary" href="' + productURL(record.h) + '">Voir la pièce</a></div>';
  }
  async function initResults(target) {
    if (target.dataset.lpaReady) return;
    target.dataset.lpaReady = '1';
    var query = target.dataset.query;
    if (!isReference(query)) return;
    var host = target.closest('.shopify-section');
    var status = target.querySelector('[data-lpa-reference-status]');
    var grid = target.querySelector('[data-lpa-reference-grid]');
    var sort = target.querySelector('[data-lpa-reference-sort]');
    var sortLabel = target.querySelector('[data-lpa-reference-sort-label]');
    var pagination = target.querySelector('[data-lpa-reference-pagination]');
    var retry = target.querySelector('[data-lpa-reference-retry]');
    var pageSize = Math.max(1, Math.min(48, Number(target.dataset.pageSize) || 24));
    var records = [];
    var renderId = 0;
    var params = new URLSearchParams(root.location.search);
    var page = Math.max(1, Number(params.get('ref_page')) || 1);
    if (params.get('sort_by') && Array.from(sort.options).some(function (option) { return option.value === params.get('sort_by'); })) sort.value = params.get('sort_by');
    function sorted() {
      return records.slice().sort(function (a, b) {
        switch (sort.value) {
          case 'price-ascending': return a.p - b.p;
          case 'price-descending': return b.p - a.p;
          case 'title-ascending': return a.t.localeCompare(b.t, 'fr');
          case 'title-descending': return b.t.localeCompare(a.t, 'fr');
          case 'created-ascending': return Number(a.c) - Number(b.c);
          case 'created-descending': return Number(b.c) - Number(a.c);
          default: return 0;
        }
      });
    }
    function updateURL() {
      var url = new URL(root.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      if (page > 1) url.searchParams.set('ref_page', page); else url.searchParams.delete('ref_page');
      root.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
    async function render(moveToTop) {
      var current = ++renderId;
      var pages = Math.max(1, Math.ceil(records.length / pageSize));
      page = Math.min(page, pages);
      status.textContent = 'Recherche en cours…';
      target.setAttribute('aria-busy', 'true');
      var selected = sorted().slice((page - 1) * pageSize, page * pageSize);
      await warmDetails(selected);
      var cards = await parallelMap(selected, 4, function (record) {
        return details(record).then(function (data) { return data.card; }).catch(function () { return fallbackCard(record); });
      });
      if (current !== renderId) return;
      grid.innerHTML = cards.map(function (html) { return '<li class="grid__item">' + html + '</li>'; }).join('');
      status.textContent = records.length + (records.length > 1 ? ' pièces trouvées pour « ' : ' pièce trouvée pour « ') + query + ' »';
      document.title = 'Recherche : ' + status.textContent + ' - ' + (config.shop || 'La Pièce Auto 42');
      pagination.hidden = pages < 2;
      pagination.innerHTML = '';
      if (pages > 1) {
        var previous = document.createElement('button');
        previous.type = 'button'; previous.textContent = 'Précédent'; previous.disabled = page === 1;
        previous.addEventListener('click', function () { page--; updateURL(); render(true); });
        var label = document.createElement('span'); label.textContent = 'Page ' + page + ' sur ' + pages;
        var next = document.createElement('button');
        next.type = 'button'; next.textContent = 'Suivant'; next.disabled = page === pages;
        next.addEventListener('click', function () { page++; updateURL(); render(true); });
        pagination.append(previous, label, next);
      }
      target.removeAttribute('aria-busy');
      if (moveToTop) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    async function run() {
      target.hidden = false;
      retry.hidden = true;
      status.textContent = 'Recherche en cours…';
      host.classList.add('lpa-reference-search-loading');
      try {
        var matches = await find(query);
        if (!matches.length) { target.hidden = true; return; }
        records = mergeResults(matches, await nativeResults(query));
        host.classList.add('lpa-reference-search-active');
        sortLabel.hidden = false;
        await render(false);
      } catch (_) {
        host.classList.remove('lpa-reference-search-active');
        status.textContent = 'La recherche par référence n’a pas pu être terminée. Vous pouvez réessayer.';
        retry.hidden = false;
      } finally { host.classList.remove('lpa-reference-search-loading'); }
    }
    sort.addEventListener('change', function () { page = 1; updateURL(); render(false); });
    retry.addEventListener('click', run);
    await run();
  }
  root.LpaReferenceSearch = { isReference: isReference, find: find, enrichPredictive: enrichPredictive };
  function boot() { document.querySelectorAll('[data-lpa-reference-results]').forEach(initResults); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // L’onglet dédié laisse charger les références pendant la saisie.
  document.addEventListener('focusin', function (event) {
    if (event.target.matches('.lpa-finder input[type="search"]')) loadIndex().catch(function () {});
  });
  document.addEventListener('shopify:section:load', boot);
})(typeof window === 'undefined' ? globalThis : window);
